import { render } from "./ButtonIcon.vue?vue&type=template&id=49cd1c3b&ts=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=ts"
export * from "./ButtonIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__